export default {
  zoneFeatures: {
    SHOW_JOBCARD_TEASER_IN_SPLITVIEW: true,
    SHOW_SALARY_TRANSPARENCY: true,
    SHOULD_OPEN_APPLY_IN_NEW_TAB: false,
    STICK_APPLY_BUTTON_ON_DESKTOP: true,
    COMPANY_PROFILE_ON_JDV: true,
  },
};
